import { getTokensFromStorage } from '../tokens/getTokensFromStorage';

export const getUserAuthState = () => {
  if (window.BX) {
    return window.BX?.User && 'NAME' in window.BX.User;
  }

  return !!getTokensFromStorage().userToken;
};
